import React, { useState, useEffect, useRef } from 'react';
import Quote from './Quote';
import useQuote from '../hooks/useQuote';
import useFavorites from '../hooks/useFavorites';

const CATEGORIES = [
    { label: 'All', value: '' },
    { label: 'Wisdom', value: 'wisdom' },
    { label: 'Life', value: 'life' },
    { label: 'Love', value: 'love' },
    { label: 'Faith', value: 'faith' },
    { label: 'Humor', value: 'humor' },
    { label: 'Success', value: 'success' },
    { label: 'Happiness', value: 'happiness' },
];

const QuoteGenerator = () => {
    const { quote, loading, error, fetchQuote } = useQuote();
    const { isFavorited, toggleFavorite } = useFavorites();
    const [shareStatus, setShareStatus] = useState('');
    const [activeCategory, setActiveCategory] = useState('');
    const shareTimerRef = useRef(null);

    useEffect(() => {
        fetchQuote('');
    }, [fetchQuote]);

    useEffect(() => {
        setShareStatus('');
    }, [quote]);

    const handleCategoryChange = (cat) => {
        setActiveCategory(cat);
        fetchQuote(cat);
    };

    const handleLike = () => {
        if (quote) toggleFavorite(quote);
    };

    const handleShare = async () => {
        if (!quote) return;
        const text = `"${quote.text}" — ${quote.author}`;
        if (navigator.share) {
            try {
                await navigator.share({ title: 'Quote', text, url: window.location.href });
                setShareStatus('Shared!');
            } catch {
                // User cancelled — no feedback needed
            }
        } else {
            try {
                await navigator.clipboard.writeText(text);
                setShareStatus('Copied to clipboard!');
            } catch {
                setShareStatus('Unable to copy. Please copy manually.');
            }
        }
        clearTimeout(shareTimerRef.current);
        shareTimerRef.current = setTimeout(() => setShareStatus(''), 3000);
    };

    return (
        <div className="quote-generator">
            <div className="category-chips">
                {CATEGORIES.map((cat) => (
                    <button
                        key={cat.value}
                        className={`category-chip${activeCategory === cat.value ? ' active' : ''}`}
                        onClick={() => handleCategoryChange(cat.value)}
                        disabled={loading}
                    >
                        {cat.label}
                    </button>
                ))}
            </div>
            {loading && <p className="status-text">Loading...</p>}
            {error && <p className="error-text">{error}</p>}
            {!loading && !error && quote && (
                <Quote
                    quote={quote}
                    liked={quote ? isFavorited(quote) : false}
                    onLike={handleLike}
                    onShare={handleShare}
                />
            )}
            {shareStatus && <p className="share-status">{shareStatus}</p>}
            <button className="generate-button" onClick={() => fetchQuote(activeCategory)} disabled={loading}>
                {loading ? 'Loading...' : 'Generate New Quote'}
            </button>
        </div>
    );
};

export default QuoteGenerator;
